import React from 'react'
import { LoadableValue } from '../../../LoadableValue'

interface IAgentInsuranceCertificationLink {
  url: string
  loading?: boolean
  index: number
}

export const AgentInsuranceCertificationLink = ({
  index,
  loading = false,
  url,
}: IAgentInsuranceCertificationLink) => {
  const number = !!index && index + 1
  return (
    <LoadableValue
      value={
        <a href={url} type='tertiary' target='_blank' rel='noopener noreferrer'>
          Certificate of Insurance {number}
        </a>
      }
      loading={loading}
    />
  )
}
